import React from 'react'

import { FaArrowAltCircleUp, FaRegArrowAltCircleUp, FaSlidersH, FaThList } from 'react-icons/fa'

import PanelHeader from '../../../elem/panel/PanelHeader'
import { IconTooltip as Tooltip } from '../../../elem/Tooltip'
import CollapseButton from '../../../elem/list/CollapseButton'

export default ({ 
    filterExpanded,
    toggleFilter,
    togglePromotedRecords,
    promotedRecords,
    setCollapsed,
    isCollapsed,
 }) => {
    return (
        <PanelHeader extraClass={'samplePanelHeader'}>
            <div className="panelHeaderText">Sample Result Explorer</div>
            <div className="panelHeaderControls">
                <div className="panelHeaderIconWrapper">
                    {!filterExpanded && (
                        <div
                            className="panelHeaderIconDiv"
                            data-tip={`${
                                promotedRecords
                                    ? `Do not promote Selected Records`
                                    : `Promote Selected Records`
                            }`}
                            data-for={`well-promoted-records-toggle-${promotedRecords}`}
                            onClick={() =>
                                togglePromotedRecords(!promotedRecords, 'sample')
                            }
                        >
                            {promotedRecords ? (
                                <FaArrowAltCircleUp />
                            ) : (
                                <FaRegArrowAltCircleUp />
                            )}
                            <Tooltip
                                id={`well-promoted-records-toggle-${promotedRecords}`}
                            />
                        </div>
                    )}
                    <div
                        className="panelHeaderIconDiv"
                        data-tip={`${
                            filterExpanded
                                ? 'View Sample Result List'
                                : 'View Sample Result Filter'
                        }`}
                        data-for={`sample-view-toggle-${filterExpanded}`}
                        onClick={() => toggleFilter(!filterExpanded)}
                    >
                        {filterExpanded ? <FaThList /> : <FaSlidersH />}
                        <Tooltip id={`sample-view-toggle-${filterExpanded}`} />
                    </div>
                    <CollapseButton
                        name={`sample-list`}
                        isCollapsed={isCollapsed}
                        setIsCollapsed={setCollapsed}
                    />
                </div>
            </div>
        </PanelHeader>
    )
}
